import { UNAUTH_USER } from './types';

export const clearUserSession = () => dispatch => {
  dispatch({ type: UNAUTH_USER });
};
